const getCsrf = () => {
  let _csrf = null;
  const element = document.head.querySelector('meta[name="csrf-token"]');

  if (element !== null) {
    _csrf = element.content;
  }
 
  return _csrf;
};

export function addCsrfHeader(config) {
  const csrfToken = getCsrf();
  if (csrfToken !== null) {
    config.headers['X-CSRF-TOKEN'] = csrfToken;
  }
  return config;
}
